export const deriveStyleFromToken = variant => {
  const style = {
    marginLeft: 0,
    marginRight: 0,
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginInlineEnd: 0,
    marginInlineStart: 0,
    marginBottom: 0,
    marginTop: 0
  };
  return {
    ...style,
    ...variant.token
  };
};